<template>
  <tr class="bg-gray-50 hover:bg-gray-100 transition-colors duration-150 ease-in-out text-right child:py-4 first-child:pl-16 last-child:pr-3 text-sm">
    <td
      class="py-3 text-left pl-3"
    >
      <div class="flex items-start space-x-2">
        <span class="font-semibold text-gray-900 flex-shrink-0">{{ variationOrder.CodeRef }}</span>

        <p class="w-60 text-gray-700">
          {{ variationOrder.description }}
        </p>
      </div>
    </td>

    <td class="pr-3">
      <VariationOrderLinkedBudget :variation-order="variationOrder" />
    </td>

    <td v-if="claim.boq_type === 'subcontractor_schedule_of_rates'" />

    <td
      v-if="variationOrderCost?.current_claim && !typingClaim && canEditClaim"
      :class="{ 'cursor-pointer': canEditClaim }"
      class="bg-green-200/50"
      @click="typeClaim"
    >
      <div class="group flex items-center justify-end">
        <button
          type="button"
          class="btn-icon group-hover:visible btn-icon-red inline-block invisible"
          @click.stop.capture="removeClaim"
        >
          <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
    />
</svg>
        </button>

        <button
          v-if="canEditClaim"
          type="button"
          class="btn-icon group-hover:visible btn-icon-blue inline-block invisible"
        >
          <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    />
</svg>
        </button>
        {{ variationOrderCost.current_claim ? australianCurrency(variationOrderCost.current_claim) : '' }}
      </div>
    </td>

    <td
      v-else-if="canEditClaim"
      class="bg-green-200/50"
    >
      <div class="w-1/2 ml-auto">
        <AppCurrencyInput
          ref="claimInput"
          v-model.number="costForm.form.current_claim"
          name="current_claim"
          type="number"
          min="1"
          class="w-20 h-6 ml-auto form-input"
          @blur="stopTypingClaim"
          @keyup.enter="stopTypingClaim"
          @keyup.esc="typingClaim = false"
        />
      </div>
    </td>

    <td
      v-else
      class="bg-green-200/50"
    >
      {{ variationOrderCost?.current_claim ? australianCurrency(variationOrderCost.current_claim) : '' }}
    </td>

    <td class="bg-green-200/50" />

    <td class="bg-green-200/50" />

    <td class="bg-green-200/50">
      {{ australianCurrency(variationOrder.previous(claim)) }}
    </td>

    <td class="bg-green-200/50 pr-3">
      {{ australianCurrency(variationOrder.previous(claim) + (variationOrderCost?.current_claim || 0)) }}
    </td>

    <td
      v-if="showPercentages && variationOrderCost?.current_claim && !typingClaim && canEditClaim && variationOrder.totalBudget"
      :class="{ 'cursor-pointer': canEditClaim }"
      class="bg-blue-100/50"
      @click="typeClaimPercent"
    >
      <div class="group flex items-center justify-end">
        <button
          type="button"
          class="btn-icon group-hover:visible btn-icon-red inline-block invisible"
          @click.stop.capture="removeClaim"
        >
          <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
    />
</svg>
        </button>

        <button
          v-if="canEditClaim"
          type="button"
          class="btn-icon group-hover:visible btn-icon-blue inline-block invisible"
        >
          <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    />
</svg>
        </button>
        {{ variationOrderCost?.current_claim ? `${australianNumber((variationOrderCost.current_claim / variationOrder.totalBudget) * 100)}%` : '' }}
      </div>
    </td>

    <td
      v-else-if="showPercentages && canEditClaim && variationOrder.totalBudget"
      class="bg-blue-100/50"
    >
      <div class="w-1/2 ml-auto">
        <AppInput
          ref="claimPercentInput"
          v-model.number="currentClaimPercent"
          name="current_claim_percent"
          type="number"
          class="w-20 h-6 ml-auto form-input"
          @blur="stopTypingClaim"
          @keyup.enter="stopTypingClaim"
          @keyup.esc="typingClaim = false"
        />
      </div>
    </td>

    <td
      v-else
      class="bg-blue-100/50"
    >
      <span v-if="showPercentages">
        {{ variationOrderCost?.current_claim && variationOrder.totalBudget ? `${australianNumber((variationOrderCost.current_claim / variationOrder.totalBudget) * 100)}%` : '' }}
      </span>
    </td>

    <td
      v-if="showPercentages"
      class="bg-blue-100/50"
    />

    <td
      v-if="showPercentages"
      class="bg-blue-100/50"
    >
      {{ variationOrder.totalBudget ? australianNumber((variationOrder.previous(claim) / variationOrder.totalBudget) * 100) + '%' : '' }}
    </td>

    <td
      v-if="showPercentages"
      class="bg-blue-100/50 pr-3"
    >
      {{ variationOrder.totalBudget ? australianNumber(((variationOrder.previous(claim) + (variationOrderCost?.current_claim || 0)) / variationOrder.totalBudget) * 100) + '%' : '' }}
    </td>

    <td class="pr-3">
      {{ variationOrder.totalBudget ? australianCurrency(variationOrder.totalBudget - variationOrder.previous(claim) - (variationOrderCost?.current_claim || 0)) : '' }}
    </td>
  </tr>
</template>

<script setup lang="ts">
import VariationOrderLinkedBudget from '@/components/shared/VariationOrderLinkedBudget.vue';
import { useFormData } from '@/composables/useFormData';
import { useSignedData } from '@/composables/useSignedData';
import { useStoreApiAction } from '@/composables/useStoreApiAction';
import { australianCurrency, australianNumber, falsey, parseUrlParams, roundDecimals } from '@/helpers';
import Claim, { ClaimStatus } from '@/models/Claim';
import VariationOrder, { VariationOrderStatus } from '@/models/VariationOrder';
import { useVariationOrderCostsStore } from '@/store/variationOrderCosts';
import Swal from 'sweetalert2';
import { computed, nextTick, ref, watch } from 'vue';

const props = defineProps<{
  variationOrder: VariationOrder;
  claim: Claim;
  showPercentages?: boolean;
}>();

const signedParams = useSignedData();
const variationOrderCostsStore = useVariationOrderCostsStore();

const variationOrderCost = computed(() => {
  return variationOrderCostsStore.models
    .where('claim_id', props.claim.id)
    .where(
      'variation_order_id',
      props.variationOrder.id,
    ).first();
});

const canEditClaim = computed(() => {
  return props.claim.status === ClaimStatus.draft_subcontractor &&
    props.variationOrder.status !== VariationOrderStatus.completed;
});

const typingClaim = ref(falsey(variationOrderCost.value?.current_claim));
const claimInput = ref();
const claimPercentInput = ref();

const typeClaim = () => {
  if(canEditClaim.value) {
    typingClaim.value = true;

    nextTick(() => {
      claimInput.value?.focusInput();
    });
  }
};

const typeClaimPercent = () => {
  if(canEditClaim.value) {
    typingClaim.value = true;

    nextTick(() => {
      claimPercentInput.value?.focusInput();
    });
  }
};

const currentClaimPercent = computed({
  get() {
    return roundDecimals((costForm.form.current_claim / props.variationOrder.totalBudget) * 100) || undefined;
  },

  set(value) {
    costForm.form.current_claim = roundDecimals((value / 100) * props.variationOrder.totalBudget);
  },
});

const costForm = useFormData({
  id: undefined,
  variation_order_id: props.variationOrder.id,
  current_claim: undefined,
});

watch(variationOrderCost, (newValue) => {
  if(newValue) {
    costForm.setData({
      id: newValue.id,
      current_claim: newValue.current_claim,
    });
  }
}, { immediate: true });

const saveClaimAction = useStoreApiAction(variationOrderCostsStore.saveSubcontractorClaim);
const deleteSubcontractorClaimAction = useStoreApiAction(variationOrderCostsStore.deleteSubcontractorClaim);

const removeClaim = () => {
  deleteSubcontractorClaimAction.request(
    props.claim.id,
    parseUrlParams(signedParams.meta.variation_claim_url as string),
    {
      id: variationOrderCost.value.id,
    },
  )
    .then(() => {
      costForm.form.id = undefined;
      costForm.form.current_claim = undefined;
      typingClaim.value = true;
    }).catch((error) => {
      if(error.status === 422) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid amount',
          text: error.data?.message,
        });
      }

      if(variationOrderCost.value) {
        costForm.form.current_claim = variationOrderCost.value.current_claim;
      }
    });
};

const stopTypingClaim = async () => {
  if(
    costForm.form.current_claim === 0 || (falsey(costForm.form.current_claim) && !variationOrderCost.value) ||
    !typingClaim.value
  ) {
    return;
  }

  if(variationOrderCost.value && falsey(costForm.form.current_claim)) {
    deleteSubcontractorClaimAction.request(
      props.claim.id,
      parseUrlParams(signedParams.meta.variation_claim_url as string),
      {
        id: variationOrderCost.value.id,
      },
    ).then(() => {
      costForm.form.id = undefined;
      costForm.form.current_claim = undefined;
      typingClaim.value = true;
    }).catch((_error) => {
      typingClaim.value = false;
    });
  } else {
    saveClaimAction.request(
      props.claim.id,
      parseUrlParams(signedParams.meta.variation_claim_url as string),
      costForm.form,
    ).then(() => {
      typingClaim.value = false;
    }).catch((error) => {
      if(error.status === 422) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid data',
          text: error.data?.message,
        });
      }

      if(variationOrderCost.value) {
        costForm.form.current_claim = variationOrderCost.value.current_claim;
      }

      typingClaim.value = false;
    });
  }
};
</script>

<style scoped></style>
